export default __webpack_public_path__ + "static/media/TIMPANO2.8f6297a9.png";